import { Grid, GridItem, Text } from '@chakra-ui/react';
import { ProviderIdentity } from '@prisma/client';

import { SimpleFieldArray } from '../SimpleFieldArray';
import { ProviderIdentityMapForm } from './ProviderIdentityMapForm';

export const ProviderIdentityForm = () => {
  const getMappedDataTitle = (field: ProviderIdentity) => {
    return (
      <Grid templateColumns="repeat(2, 1fr)" w="full">
        <GridItem>
          <Text fontFamily="monospace">{field?.system}</Text>
        </GridItem>
        <GridItem>
          <Text fontFamily="monospace">{field?.value}</Text>
        </GridItem>
      </Grid>
    );
  };

  return (
    <SimpleFieldArray
      name="provider_identities"
      form={ProviderIdentityMapForm}
      canAdd
      canRemove
      accordionTitle={getMappedDataTitle}
      ignoreStyles
    />
  );
};
